import React, { useEffect, useRef, useState } from 'react';

const ParticleBackground = () => {
  const canvasRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Определение мобильного устройства
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animationFrameId;
    let lastTime = 0;
    // Еще больше снижаем частоту обновления для мобильных устройств
    let frameRate = isMobile ? 1000 / 20 : 1000 / 30;
    
    // Установка размеров canvas
    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    
    window.addEventListener('resize', handleResize);
    handleResize();
    
    // Настройка частиц
    const particlesArray = [];
    // Уменьшаем количество частиц для мобильных устройств
    const numberOfParticles = isMobile ? 20 : 70;
    
    class Particle {
      constructor() {
        this.x = Math.random() * canvas.width;
        this.y = Math.random() * canvas.height;
        this.size = Math.random() * 2 + 1;
        // Снижаем скорость движения для экономии ресурсов
        this.speedX = (Math.random() * 0.8 - 0.4) * (isMobile ? 0.3 : 1);
        this.speedY = (Math.random() * 0.8 - 0.4) * (isMobile ? 0.3 : 1);
        this.color = this.getRandomColor();
        // Кэшируем предрассчитанное значение для оптимизации
        this.cachedAlpha = 0.2;
      }
      
      getRandomColor() {
        const colors = [
          'rgba(124, 58, 237, 0.3)',  // purple
          'rgba(219, 39, 119, 0.2)',  // pink
          'rgba(59, 130, 246, 0.25)',  // blue
        ];
        return colors[Math.floor(Math.random() * colors.length)];
      }
      
      update() {
        this.x += this.speedX;
        this.y += this.speedY;
        
        if (this.x > canvas.width) this.x = 0;
        else if (this.x < 0) this.x = canvas.width;
        
        if (this.y > canvas.height) this.y = 0;
        else if (this.y < 0) this.y = canvas.height;
      }
      
      draw() {
        ctx.fillStyle = this.color;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fill();
      }
    }
    
    // Создание частиц
    const init = () => {
      particlesArray.length = 0; // Очищаем массив при изменении размера
      for (let i = 0; i < numberOfParticles; i++) {
        particlesArray.push(new Particle());
      }
    };
    
    init();
    
    // Анимация частиц с учётом временных интервалов
    const animate = (timestamp) => {
      const deltaTime = timestamp - lastTime;
      
      // Пропускаем кадр, если не прошло нужное количество времени
      if (deltaTime >= frameRate) {
        lastTime = timestamp - (deltaTime % frameRate);
        
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        for (let i = 0; i < particlesArray.length; i++) {
          particlesArray[i].update();
          particlesArray[i].draw();
          
          // На мобильных устройствах рисуем меньше соединений между частицами
          if (isMobile) {
            // Проверяем только каждую 5-ю частицу для экономии ресурсов
            for (let j = i; j < particlesArray.length; j += 5) {
              const dx = particlesArray[i].x - particlesArray[j].x;
              const dy = particlesArray[i].y - particlesArray[j].y;
              // Используем приближённое расстояние для экономии ресурсов
              const distance = Math.abs(dx) + Math.abs(dy); // Манхэттенское расстояние
              
              if (distance < 100) {
                ctx.beginPath();
                ctx.strokeStyle = `rgba(124, 58, 237, ${0.1 - distance/1000})`;
                ctx.lineWidth = 0.5;
                ctx.moveTo(particlesArray[i].x, particlesArray[i].y);
                ctx.lineTo(particlesArray[j].x, particlesArray[j].y);
                ctx.stroke();
              }
            }
          } else {
            // На десктопах можем позволить себе больше соединений
            for (let j = i; j < particlesArray.length; j++) {
              const dx = particlesArray[i].x - particlesArray[j].x;
              const dy = particlesArray[i].y - particlesArray[j].y;
              const distance = Math.sqrt(dx * dx + dy * dy);
              
              if (distance < 100) {
                ctx.beginPath();
                ctx.strokeStyle = `rgba(124, 58, 237, ${0.2 - distance/500})`;
                ctx.lineWidth = 0.5;
                ctx.moveTo(particlesArray[i].x, particlesArray[i].y);
                ctx.lineTo(particlesArray[j].x, particlesArray[j].y);
                ctx.stroke();
              }
            }
          }
        }
      }
      
      animationFrameId = requestAnimationFrame(animate);
    };
    
    animationFrameId = requestAnimationFrame(animate);
    
    // Очистка при размонтировании
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('resize', checkMobile);
      cancelAnimationFrame(animationFrameId);
    };
  }, [isMobile]);
  
  return (
    <canvas 
      ref={canvasRef} 
      className="fixed top-0 left-0 w-full h-full -z-10 opacity-40"
    />
  );
};

export default ParticleBackground; 